import router from './router'

// 全局前置守卫
router.beforeEach((to, from, next) => {
  document.title = `${to.name}`;
  if(localStorage.getItem('zyx_admin_token') || to.path === '/login'){
    next()
  } else {
    next({ path: '/login' })
  }
})



// WEBPACK FOOTER //
// ./src/routeguard.js